import React, { useState, useEffect } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Alert } from 'reactstrap'
import { useMutation } from '@apollo/client'
import { CREATE_INBOX, UPDATE_INBOX } from './Mutations'

export default function CreateEditInboxModal({ isOpen, toggle, inbox, onSuccess }) {
    const [name, setName] = useState('')
    const [errors, setErrors] = useState([])

    const isEdit = !!inbox

    useEffect(() => {
        if (inbox) {
            setName(inbox.name || '')
        } else {
            setName('')
        }
        setErrors([])
    }, [inbox, isOpen])

    const [createInbox, { loading: creating }] = useMutation(CREATE_INBOX, {
        onCompleted: (data) => {
            if (data.messagingCreateInbox.ok) {
                toggle()
                if (onSuccess) onSuccess('Inbox created successfully.')
            } else {
                setErrors(data.messagingCreateInbox.errors || ['Failed to create inbox'])
            }
        },
        onError: (error) => {
            setErrors([error.message])
        }
    })

    const [updateInbox, { loading: updating }] = useMutation(UPDATE_INBOX, {
        onCompleted: (data) => {
            if (data.messagingUpdateInbox.ok) {
                toggle()
                if (onSuccess) onSuccess('Inbox updated successfully.')
            } else {
                setErrors(data.messagingUpdateInbox.errors || ['Failed to update inbox'])
            }
        },
        onError: (error) => {
            setErrors([error.message])
        }
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        setErrors([])

        if (!name.trim()) {
            setErrors(['Name is required'])
            return
        }

        if (isEdit) {
            updateInbox({
                variables: {
                    id: inbox.id,
                    name: name.trim()
                }
            })
        } else {
            createInbox({
                variables: {
                    name: name.trim()
                }
            })
        }
    }

    const loading = creating || updating

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader>
                {isEdit ? 'Edit Inbox' : 'Create New Inbox'}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {errors.length > 0 && (
                        <Alert color="danger">
                            {errors.map((error, idx) => (
                                <div key={idx}>{error}</div>
                            ))}
                        </Alert>
                    )}
                    <FormGroup>
                        <Label for="inboxName">Name *</Label>
                        <Input
                            type="text"
                            id="inboxName"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter inbox name"
                            disabled={loading}
                            required
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="primary" type="submit" disabled={loading}>
                        {loading ? 'Saving...' : isEdit ? 'Update' : 'Create'}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    )
}
